module.exports = __webpack_public_path__ + "static/media/LoadingGif.91648833.gif";